import { gql } from '@apollo/client';
import { useAuthedQuery } from 'utils/qlAuth';

export const useStoryFramesQuery = (storyId: number) => {
  return useAuthedQuery(
    gql`
      query FrameController_getStoryFrames($storyId: Int!) {
        FrameController_getStoryFrames(storyId: $storyId) {
          id
          promt
          tts
          status
          timeStart
          timeLength
          initText
          motion
          motionPromt
          presetStyle
          images
          videos
          videoCatStop
          videoCatStart
          videoSpeed
          tags
          frameIndex
          reactions
        }
      }
    `,
    {
      variables: { storyId: Number(storyId) },
    },
  );
};

// Функция для сравнения двух промтов
export function comparePrompts(a: string, b: string) {
  const r = String(a) === String(b);

  return r;
}
